// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".download-icon{display:block;margin-left:auto;margin-right:auto;height:210px}.success-icon{color:#28c75d}\n", ""]);
// Exports
module.exports = exports;
